/* eslint-disable no-unused-vars */
// import axios from 'axios'
import axios from '../../helpers/Axios'
import moment from 'moment'

export const maintenancemodule = {

	namespaced: true,

	state: {
		currentMaintenance: {},
		dateString: '',
		endDate: null,
		stateClass: ''
	},
	getters: {
		currentMaintenance: state => { return state.currentMaintenance; },
		dateString: state => { return state.dateString; },
		stateClass: state => { return state.stateClass; }
	},
	actions: {
		getMaintenance({ commit, state, dispatch }) {

			return axios.get('/maintenance/').then(response => {
				
				var startDate = moment(response.data.maintenanceDueDateTimeString, 'DD/MM/YYYY HH:mm')
				var start = startDate.format('DD/MM h:mma');
				var endDate = startDate.add(response.data.maintenanceLength, 'minutes');
				var end = endDate.format('h:mma');
				commit('dateString', start + ' - ' + end);
				commit('currentMaintenance', response.data);

				console.log(startDate.add(-1, 'hour').toDate(), new Date())

				if (startDate.add(-1, 'hour').toDate() < new Date()) {
					commit('stateClass', 'warn');
				} else if (endDate.toDate() < new Date()) {
					commit('stateClass', 'success');
				} else {
					commit('stateClass', '');
				}

			}).catch(err => {
				console.log(err);
				global.location.replace('/error/error404');
			});
		}
	},
	mutations: {

		currentMaintenance(state, info) {
			state.currentMaintenance = info
		},
		dateString(state, info) {
			state.dateString = info
		},
		stateClass(state, info) {
			state.stateClass = info
		}
	}
}
